export { default } from './fbt-title';
